const t = "단계 완료됨", o = "{buttonName} 단계로 돌아가기", e = "{buttonName}로 계속", n = {
  completedStep: t,
  backButton: o,
  nextButton: e
};
export {
  o as backButton,
  t as completedStep,
  n as default,
  e as nextButton
};
